import Menu from './components/menu'
import DropDown from './components/dropdown'

$(document).ready(function () {
  if($('.header').length > 0) {
    new Menu()
    new DropDown('#js-dropdown-lang')
    $(document).scroll(function() {
      if ($(document).scrollTop() >= 1) {
        $('.header').css("background-color","#177f67")
        $('.header__top').css("display","none")
        if ($(window).width() > 991) {
          $('.header').css("height","120px")
          $('.header__logo-img').css("width","40%")
        }
        else {
          $('.header').css("height","90px")
        }
      } else {
        $('.header').css("background-color","transparent")
        $('.header__top').css("display","block")
        if ($(window).width() > 991) {
          $('.header').css("height","300px")
          $('.header__logo-img').css("width","100%")
        }
        else {
          $('.header').css("height","150px")
        }
      }
    });
    if ($(document).scrollTop() >= 1) {
      $('.header').css("background-color","#177f67")
      $('.header__top').css("display","none")
      if ($(window).width() > 991) {
        $('.header').css("height","120px")
        $('.header__logo-img').css("width","40%")
      }
      else {
        $('.header').css("height","90px")
      }
    } else {
      $('.header').css("background-color","transparent")
      $('.header__top').css("display","block")
      if ($(window).width() > 991) {
        $('.header').css("height","300px")
        $('.header__logo-img').css("width","100%")
      }
      else {
        $('.header').css("height","150px")
      }
    }
  }
});